import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";
import { AiOutlineEdit, AiOutlineClose } from "react-icons/ai";
import { actualizaReporte } from "../../Services/Rest";

// 🔥 accesibilidad obligatoria
ReactModal.setAppElement("#root");

function EditarReporte({ idReporte }) {
  const [isOpen, setIsOpen] = useState(false);
  const [nombre, setNombre] = useState("");
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  // 🚀 GUARDAR OPTIMIZADO
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nombre && !url) {
      Swal.fire({
        icon: "warning",
        title: "Campos vacíos",
        text: "Debes ingresar al menos un valor",
      });
      return;
    }

    try {
      setLoading(true);

      await axios({
        auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
        method: "put",
        url: actualizaReporte + idReporte,
        data: {
          ...(nombre && { nombre }),
          ...(url && { url }),
        },
      });

      Swal.fire({
        icon: "success",
        title: "Actualizado correctamente",
        timer: 1500,
        showConfirmButton: false,
      });

      closeModal();

      // 🔥 mejor que reload completo
      setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo actualizar",
      });
    } finally {
      setLoading(false);
    }
  };

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0,0,0,0.6)",
      zIndex: 2000,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "420px",
      borderRadius: "12px",
      padding: "0",
      border: "none",
    },
  };

  return (
    <>
      {/* 🔥 BOTÓN */}
      <button
        className="btn btn-outline-warning btn-sm d-flex align-items-center gap-1"
        onClick={openModal}
      >
        <AiOutlineEdit />
        Editar
      </button>

      {/* 🔥 MODAL */}
      <ReactModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={customStyles}
      >
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px 16px",
            borderBottom: "1px solid #eee",
            background: "#f9fafb",
          }}
        >
          <span style={{ fontWeight: 600 }}>Editar Reporte</span>

          <button
            onClick={closeModal}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              fontSize: "18px",
            }}
          >
            <AiOutlineClose />
          </button>
        </div>

        {/* FORM */}
        <form
          onSubmit={handleSubmit}
          style={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          <input
            type="text"
            placeholder="Nuevo nombre"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            className="form-control"
          />

          <input
            type="text"
            placeholder="Nueva URL"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="form-control"
          />

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "Guardando..." : "Guardar cambios"}
          </button>
        </form>
      </ReactModal>
    </>
  );
}

export default EditarReporte;
